<template>
  <div>
    <el-card shadow="always">
      <edit-form
        class="mr-2 ml-2"
        ref="editForm"
        :disabled="isDisableEditForm"
        :amzMoqCode="params.code"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-base-awsMoqSet-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
